import React, { useEffect, useState } from 'react';

const CountdownTimer = ({ initialSeconds = 30, onTimeout, resetSignal }) => {
  const [seconds, setSeconds] = useState(initialSeconds);


   useEffect(() => {
    setSeconds(initialSeconds); // reset on resetSignal change
  }, [resetSignal]);


  useEffect(() => {
    if (seconds <= 0) {
      onTimeout?.();
      return;
    }
    const interval = setInterval(() => setSeconds((s) => s - 1), 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  return(<>
  <p className={`otp-timer ${seconds == 0 ? 'inactive-time' : ''}`}>{formatTime(seconds)}</p>
  </>
);
}

export default CountdownTimer;
